import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteGoogleTool.errors');
export const getLoadSiteGoogleToolError = state => (
  _get(getErrors(state), 'loadSiteGoogleToolError')
);
export const getUploadSiteGoogleToolFileError = state => (
  _get(getErrors(state), 'uploadSiteGoogleToolFileError')
);
export const getDeleteSiteGoogleToolError = state => (
  _get(getErrors(state), 'deleteSiteGoogleToolError')
);
